import {getTradeCollectionPath, type TradeDb} from '@cp/model';
import {doc, DocumentReference} from 'firebase/firestore';
import {firebaseFirestore} from '../../config/firebase';

/**
 * Get a trade document reference
 * @param uid
 * @param docId
 * @returns
 */
export function getTradeDocRef(uid: string, docId: string): DocumentReference<TradeDb> {
  return doc(firebaseFirestore, getTradeCollectionPath(uid), docId) as DocumentReference<TradeDb>;
}
